import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

const discardInputDataEditSession = async (params: { sessionId: string }) =>
  apiClient
    .delete(expand(InputDataEditSessionUrl.discard, params))
    .then((response) => response.data);

export const useDiscardInputDataEditSessionMutation = createApiMutationHook(
  ['input-data-edit-session-discard'],
  discardInputDataEditSession,
);
